export default {
  TEXT: 'text',
  RANK: 'rank',
  MULTI_CHOICE: 'multi-choice',
  SINGLE_CHOICE: 'single-choice',
};
